
import React from 'react';
import {DashboardContainer} from "../../funcs/utils";
import { AllocationClassification } from "../../../lib/proto/security_classification";
import {DashboardTable} from "../dashboard-table";
import { sprintf } from "sprintf-js";

const arr_eq = (arr_0, arr_1) => {
  if (arr_0.length !== arr_1.length) {
    return false;
  }
  for(let i=0 ; i < arr_0.length; i++) {
    if (arr_0[i] !== arr_1[i]) {
      return false;
    }
  }
  return true;
}

/**
 * etf_orders is an array of ETF orderings for the scores. This
 * aggregates the scores into groups with consistent ordering.
 *
 * @param etf_orders [[String]]
 * @param scores [Object]
 * @return [ {
 *   order: [String],
 *   scores: [Object]
 *  } ]
 */
const aggregate_scores = (etf_orders, scores) => {
  let current = {
    order: etf_orders[0],
    scores: [],
  }
  const result = [ current ];

  for(let i=0; i < etf_orders.length; i++) {
    if (!arr_eq(current.order, etf_orders[i])) {
      current = {
        order: etf_orders[i],
        scores: [],
      }
      result.push(current);
    }
    current.scores.push(scores[i]);
  }
  return result
}

class SAIRR extends React.Component {

  componentDidMount() {
    const irr = this.props.irr
    if (!irr.category || !irr.scores) {
      this.props.loadIRRScores();
    }
  }

  score_etfs = etfs => score => {
    const curr_etfs = Array.from(etfs);
    curr_etfs.sort((etf_0, etf_1) => {
      const sc_0 = score.SCORES[etf_0].score;
      const sc_1 = score.SCORES[etf_1].score;
      if (sc_0 > sc_1) {
        return -1;
      }
      if (sc_0 < sc_1) {
        return 1;
      }
      return 0;
    });
    return curr_etfs;
  }

  render_category = category => {
    const title_style = {
      fontSize: "1.5rem",
      fontWeight: "bold",
    }
    const etfs = Array.from(this.props.irr.category[category].syms);

    // Sort each score
    const etf_orders = this.props.irr.scores.map(this.score_etfs(etfs));

    // Different ETF orderings aggregate the scores into separate tables
    const score_segments = aggregate_scores(etf_orders, this.props.irr.scores);

    const data = [];

    score_segments.forEach((segment, segment_index) => {

      const etfs = segment.order;
      const sym_header = [ "" ];
      const score_header = [ "Year/Month" ];
      const span_style = {
        fontWeight: "bold",
      }
      etfs.forEach(etf => {
        sym_header.push((<span style={span_style}>{etf}</span>), "", "", "");
        score_header.push("IRR");
        score_header.push("Dividend Yield");
        score_header.push("Expense Ratio");
        score_header.push("Score");
      });

      data.push(sym_header);
      if (segment_index === 0) {
        data.push(score_header);
      }

      const scores = segment.scores;
      for (let i=0; i < scores.length; i++) {
        const score = scores[i];
        const curr_score = [];

        curr_score.push(sprintf("%04d-%02d", score.year, score.month));

        etfs.forEach(etf => {
          curr_score.push(sprintf("%.10f", score.SCORES[etf].irr));
          curr_score.push(sprintf("%.3f", score.SCORES[etf].div_yld * 100));
          curr_score.push(sprintf("%.3f", score.SCORES[etf].expense_ratio * 100));
          curr_score.push(sprintf("%.3f", score.SCORES[etf].score));
        })

        data.push(curr_score);
      }
    })

    const table_style = {
      marginTop: "0",
    }
    const container_style = {
      marginTop: "1rem",
      overflowX: "auto",
    }
    const td_style_rules = [
      {
        pred: (row, col) => (col - 1) % 4 === 0 && row > 1,
        style: {
          borderLeft: "solid 1px black",
          paddingLeft: "0.3rem",
        }
      },
      {
        pred: (row, col) => row === 1,
        style: {
          borderBottom: "solid 1px black",
        }
      },
      {
        pred: (row, col) => row > 1 && row % 2,
        style: {
          backgroundColor: "#EEE",
        }
      }
    ]
    return (
      <div key={category} style={container_style}>
        <div style={title_style}>{AllocationClassification[category].label}</div>
        <div>
          <DashboardTable
            tableStyle={table_style}
            tdStyleLut={td_style_rules}
            data={data}/>
        </div>
      </div>
    )
  }

  maybe_render_scores = () => {
    const irr = this.props.irr;

    if (!irr.category || !irr.scores) {
      return null;
    }

    const category_items = Object.keys(irr.category).map(
      category => this.render_category(category));

    return (
      <div>
        { category_items }
      </div>
    )
  }

  render = () => {

    const client = this.props.client;

    return (
      <div className={"img-col"} id={"irr"}>
        <DashboardContainer
          title={"IRR Scores"}
          client={client}>
          { this.maybe_render_scores() }
        </DashboardContainer>
      </div>
    )
  }

}

export { SAIRR };
